export default __webpack_public_path__ + "static/media/logo.df0866ff.png";